import React, {Fragment, useEffect} from 'react';
import M from 'materialize-css';
import { useAuth } from '../Context/Context';
import { WavyLink } from "react-wavy-transitions";

import servicios1 from '../Images/Servicios/1.png';
import servicios2 from '../Images/Servicios/2.png';
import servicios3 from '../Images/Servicios/3.png';
import servicios4 from '../Images/Servicios/4.png';
import servicios5 from '../Images/Servicios/5.png';
import servicios6 from '../Images/Servicios/6.png';
import servicios7 from '../Images/Servicios/7.png';
import servicios8 from '../Images/Servicios/8.png';
import servicios9 from '../Images/Servicios/9.png';

import Contacto from '../Components/Contacto'


const Servicios = () => {
    const { direction, cambio } = useAuth();
    
    useEffect(() => {
      var elems = document.querySelectorAll('.sidenav');
      M.Sidenav.init(elems);
    });

    const hover = e => {
        let image_zoom;
        // efect_imagen
        if (e.target.id === "commerce_servicio") {
            image_zoom = document.getElementById("commerce_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen zoom_imagen";
        } else if (e.target.id === "apps_servicio") {
            image_zoom = document.getElementById("apps_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen-2 zoom_imagen";
        } else if (e.target.id === "web_servicio") {
            image_zoom = document.getElementById("web_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen-3 zoom_imagen";
        } else if (e.target.id === "erp_servicio") {
            image_zoom = document.getElementById("erp_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen zoom_imagen";
        } else if (e.target.id === "ads_servicio") {
            image_zoom = document.getElementById("ads_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen-4 zoom_imagen";
        } else if (e.target.id === "seo_servicio") {
            image_zoom = document.getElementById("seo_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen-4 zoom_imagen";
        } else if (e.target.id === "animacion_servicio") {
            image_zoom = document.getElementById("animacion_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen-3 zoom_imagen";
        } else if (e.target.id === "digital_servicio") {
            image_zoom = document.getElementById("digital_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen-2 zoom_imagen";
        } else if (e.target.id === "mantenimiento_servicio") {
            image_zoom = document.getElementById("mantenimiento_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen zoom_imagen";
        }
    }

    const hoverOut = e => {
        let image_zoom;
        if (e.target.id === "commerce_servicio") {
            image_zoom = document.getElementById("commerce_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen efect_imagen";
        } else if (e.target.id === "apps_servicio") {
            image_zoom = document.getElementById("apps_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen-2 efect_imagen";
        } else if (e.target.id === "web_servicio") {
            image_zoom = document.getElementById("web_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen-3 efect_imagen";
        } else if (e.target.id === "erp_servicio") {
            image_zoom = document.getElementById("erp_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen efect_imagen";
        } else if (e.target.id === "ads_servicio") {
            image_zoom = document.getElementById("ads_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen-4 efect_imagen";
        } else if (e.target.id === "seo_servicio") {
            image_zoom = document.getElementById("seo_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen-4 efect_imagen";
        } else if (e.target.id === "animacion_servicio") {
            image_zoom = document.getElementById("animacion_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen-3 efect_imagen";
        } else if (e.target.id === "digital_servicio") {
            image_zoom = document.getElementById("digital_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen-2 efect_imagen";
        } else if (e.target.id === "mantenimiento_servicio") {
            image_zoom = document.getElementById("mantenimiento_servicio_img");
            image_zoom.className = "center-img dimensionar-imagen efect_imagen";
        }
    }

    return (
        <Fragment>

            <div className="fondo-servicios flexbox-servicios-movil" style={{display:"flex", justifyContent:"center", flexDirection:"column", marginTop:"20px"}}>

                <div className='container'>
                    <p className='titulo_nv_1 centrar-texto' style={{color:"#ffffff", marginBottom:"-10px"}}>
                        Encuentra justo
                    </p>
                    <p className='titulo_nv_2 centrar-texto' style={{color:"#B5FCFD", margin:"0px"}}>
                        lo que necesitas
                    </p>
                    <p className='centrar-texto' style={{color:"#ffffff"}}>
                        Creemos en el poder de la tecnología <br />
                        y en la fuerza para hacer crecer cada negocio.
                    </p>
                </div>
                <div className='container center-btn'>
                    <WavyLink direction={direction ? "up" : "down"} to="/contacto" color={direction ? "#BF1F60" : "#2A79B0"}>
                        <p class="boton btn-principal z-depth-4" onClick={cambio} style={{width:"270px", margin:"0px"}}>
                            Empecemos tu proyecto 
                        </p>
                    </WavyLink>
                    {/* <a class="boton btn-principal z-depth-4" href='/contacto' style={{width:"270px"}}>
                        Empecemos tu proyecto 
                    </a>  */}
                </div>

            </div>

            <br></br>

            <div className='row hide-on-med-and-down'>
                <div className='col l8'>
                    <div className='contenedor-servicios-5 flexbox-servicios' style={{margin:"10px"}}>
                        <div className='row'>
                            <div className='col l6'>
                                <img id='commerce_servicio_img' className="center-img dimensionar-imagen" alt="" src={servicios1}></img>
                            </div>
                            <div className='col l6' style={{display:"flex", flexDirection:"column", justifyContent:"center"}}>
                                <p className='titulo-servicios' style={{fontWeight:"bold", paddingLeft:"30px"}}>E-commerce</p>
                                <p className='padding_ecommerce' style={{padding:"0px 30px", marginTop:"0px"}}>
                                    Tu tienda online está disponible para tus clientes las 24 horas del día...
                                </p>
                                <div>
                                    <WavyLink direction={direction ? "up" : "down"} to="/servicio/e-commerce" color={direction ? "#BF1F60" : "#2A79B0"}>
                                        <p class="boton_2 btn-servicios-3" id='commerce_servicio' onMouseOver={hover} onMouseOut={hoverOut} onClick={cambio} style={{margin:"0 25px"}}>
                                            Conoce más 
                                        </p>
                                    </WavyLink>
                                </div>
                                {/* <a style={{marginLeft:"30px"}} class="boton_2 btn-servicios-3" id='commerce_servicio' href='/servicio/e-commerce' onMouseOver={hover} onMouseOut={hoverOut}> 
                                    Conoce más 
                                </a>     */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col l4'>
                    <div className='contenedor-servicios-5 flexbox-servicios' style={{margin:"10px 10px 10px -10px"}}>
                        <img id='apps_servicio_img' className="center-img dimensionar-imagen-2" alt="" src={servicios2}></img>
                        <p className='titulo-servicios' style={{textAlign:"center", fontWeight:"bold"}}>Apps</p>
                        <p className='padding_app' style={{textAlign:"center", padding:"0px 30px", marginTop:"0px"}}>
                            Aplicaciones con fines corporativos, recreativos o de marketing...
                        </p>
                        <div className='centrar-boton'>
                            <WavyLink direction={direction ? "up" : "down"} to="/servicio/aplicacion-movil" color={direction ? "#BF1F60" : "#2A79B0"}>
                                <p class="boton_2 btn-servicios-3" id='apps_servicio' onMouseOver={hover} onMouseOut={hoverOut} onClick={cambio} style={{margin:"0px"}}>
                                    Conoce más 
                                </p>
                            </WavyLink>
                            {/* <a class="boton_2 btn-servicios-3" id='apps_servicio' href='/servicio/aplicacion-movil' onMouseOver={hover} onMouseOut={hoverOut}> Conoce más </a>     */}
                        </div>
                    </div>
                </div>
                <div className='col l4'>
                    <div className='contenedor-servicios-5 flexbox-servicios' style={{margin:"10px"}}>
                        <img id='web_servicio_img' className="center-img dimensionar-imagen-3" alt="" src={servicios3}></img>
                        <p className='titulo-servicios' style={{textAlign:"center", fontWeight:"bold"}}>Páginas web</p>
                        <p className='padding_web' style={{textAlign:"center", padding:"0px 30px", marginTop:"0px"}}>
                            Diseñamos y programamos páginas web, cátalogos, menús digitales y más...
                        </p>
                        <div className='centrar-boton'>
                            <WavyLink direction={direction ? "up" : "down"} to="/servicio/pagina-web" color={direction ? "#BF1F60" : "#2A79B0"}>
                                <p class="boton_2 btn-servicios-3" id='web_servicio' onMouseOver={hover} onMouseOut={hoverOut} onClick={cambio} style={{margin:"0px"}}>
                                    Conoce más 
                                </p>
                            </WavyLink>
                            {/* <a class="boton_2 btn-servicios-3" id='web_servicio' href='/servicio/pagina-web' onMouseOver={hover} onMouseOut={hoverOut}> Conoce más </a>     */}
                        </div>
                    </div>
                </div>
                <div className='col l8'>
                    <div className='contenedor-servicios-5 flexbox-servicios' style={{margin:"10px 10px 10px -10px"}}>
                        <div className='row'>
                            <div className='col l6'>
                                <img id='erp_servicio_img' className="center-img dimensionar-imagen" alt="" src={servicios4}></img>
                            </div>
                            <div className='col l6' style={{display:"flex", flexDirection:"column", justifyContent:"center"}}>
                                <p className='titulo-servicios' style={{fontWeight:"bold", paddingLeft:"30px"}}>Sistemas empresariales</p>
                                <p className='padding_ecommerce' style={{padding:"0px 30px", marginTop:"0px"}}>
                                    Automatiza los procesos de tu empresa (área de finanzas, comercial, logística, producción, etc.)
                                </p>
                                <div>
                                    <WavyLink direction={direction ? "up" : "down"} to="/servicio/sistemas-empresariales" color={direction ? "#BF1F60" : "#2A79B0"}>
                                        <p class="boton_2 btn-servicios-3" id='erp_servicio' onMouseOver={hover} onMouseOut={hoverOut} onClick={cambio} style={{margin:"0 25px"}}>
                                            Conoce más 
                                        </p>
                                    </WavyLink>
                                </div>
                                {/* <a style={{marginLeft:"30px"}} class="boton_2 btn-servicios-3" id='erp_servicio' href='/servicio/sistemas-empresariales' onMouseOver={hover} onMouseOut={hoverOut}> 
                                    Conoce más 
                                </a>     */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col l4'>
                    <div className='contenedor-servicios-4 flexbox-servicios' style={{margin:"10px"}}>
                        <img id='ads_servicio_img' className="center-img dimensionar-imagen-4" alt="" src={servicios5}></img>
                        <p className='titulo-servicios' style={{textAlign:"center", fontWeight:"bold", padding:"0px 30px"}}>
                            Campaña Google ADS
                        </p>
                        <p className='padding_ads' style={{textAlign:"center", padding:"0px 40px", marginTop:"0px"}}>
                            Realizamos campañas de busqueda con anuncios de texto o de llamada...
                        </p>
                        <div className='centrar-boton'>
                            <WavyLink direction={direction ? "up" : "down"} to="/servicio/google-ads" color={direction ? "#BF1F60" : "#2A79B0"}>
                                <p class="boton_2 btn-servicios-3" id='ads_servicio' onMouseOver={hover} onMouseOut={hoverOut} onClick={cambio} style={{margin:"0"}}>
                                    Conoce más 
                                </p>
                            </WavyLink>
                            {/* <a class="boton_2 btn-servicios-3" id='ads_servicio' href='/servicio/google-ads' onMouseOver={hover} onMouseOut={hoverOut}> Conoce más </a>     */}
                        </div>
                    </div>
                </div>
                <div className='col l4'>
                    <div className='contenedor-servicios-4 flexbox-servicios' style={{margin:"10px 10px 10px -10px"}}>
                        <p className='titulo-servicios' style={{textAlign:"center", fontWeight:"bold", padding:"0px 30px"}}>
                            Optimización SEO
                        </p>
                        <p className='padding_ads' style={{textAlign:"center", padding:"0px 36px", marginTop:"0px"}}>
                            Realizamos un conjunto de acciones orientadas a mejorar el posicionamiento...
                        </p>
                        <div className='centrar-boton' style={{marginBottom:"0px"}}>
                            <WavyLink direction={direction ? "up" : "down"} to="/servicio/pagina-web#seo" color={direction ? "#BF1F60" : "#2A79B0"}>
                                <p class="boton_2 btn-servicios-3" id='seo_servicio' onMouseOver={hover} onMouseOut={hoverOut} onClick={cambio} style={{margin:"0"}}>
                                    Conoce más 
                                </p>
                            </WavyLink>
                            {/* <a class="boton_2 btn-servicios-3" id='seo_servicio' href='/servicio/pagina-web#seo' onMouseOver={hover} onMouseOut={hoverOut}> Conoce más </a>     */}
                        </div>
                        <img id='seo_servicio_img' className="center-img dimensionar-imagen-4" alt="" src={servicios6}></img>
                    </div>
                </div>
                <div className='col l4'>
                    <div className='contenedor-servicios-4 flexbox-servicios' style={{margin:"10px 10px 10px -10px"}}>
                        <img id='animacion_servicio_img' className="center-img dimensionar-imagen-3" alt="" src={servicios7}></img>
                        <p className='titulo-servicios' style={{textAlign:"center", fontWeight:"bold"}}>Animación</p>
                        <p className='padding_web' style={{textAlign:"center", padding:"0px 30px", marginTop:"0px"}}>
                            Cualquier novedad de tu empresa muéstrala con un vídeo animado...
                        </p>
                        <div className='centrar-boton'>
                            <WavyLink direction={direction ? "up" : "down"} to="/servicio/animacion" color={direction ? "#BF1F60" : "#2A79B0"}>
                                <p class="boton_2 btn-servicios-3" id='animacion_servicio' onMouseOver={hover} onMouseOut={hoverOut} onClick={cambio} style={{margin:"0"}}>
                                    Conoce más 
                                </p>
                            </WavyLink>
                            {/* <a class="boton_2 btn-servicios-3" id='animacion_servicio' href='/servicio/animacion' onMouseOver={hover} onMouseOut={hoverOut}> Conoce más </a>     */}
                        </div>
                    </div>
                </div>
                <div className='col l4'>
                    <div className='contenedor-servicios-5 flexbox-servicios' style={{margin:"10px"}}>
                        <img id='digital_servicio_img' className="center-img dimensionar-imagen-2" alt="" src={servicios8}></img>
                        <p className='titulo-servicios' style={{textAlign:"center", fontWeight:"bold"}}>Diseño digital</p>
                        <p className='padding_ads' style={{textAlign:"center", padding:"0px 30px", marginTop:"0px"}}>
                            Renueva tu identidad corporativa con detalles que hacen la diferencia...
                        </p>
                        <div className='centrar-boton'>
                            <WavyLink direction={direction ? "up" : "down"} to="/servicio/branding" color={direction ? "#BF1F60" : "#2A79B0"}>
                                <p class="boton_2 btn-servicios-3" id='digital_servicio' onMouseOver={hover} onMouseOut={hoverOut} onClick={cambio} style={{margin:"0"}}>
                                    Conoce más 
                                </p>
                            </WavyLink>
                            {/* <a class="boton_2 btn-servicios-3" id='digital_servicio' href='/servicio/branding' onMouseOver={hover} onMouseOut={hoverOut}> Conoce más </a>     */}
                        </div>
                    </div>
                </div>
                <div className='col l8'>
                    <div className='contenedor-servicios-5 flexbox-servicios' style={{margin:"10px 10px 10px -10px"}}>
                        <div className='row'>
                            <div className='col l6'>
                                <img id='mantenimiento_servicio_img' className="center-img dimensionar-imagen" alt="" src={servicios9}></img>
                            </div>
                            <div className='col l6' style={{display:"flex", flexDirection:"column", justifyContent:"center"}}>
                                <p className='titulo-servicios' style={{fontWeight:"bold", paddingLeft:"30px"}}>
                                    Mantenimiento a equipos
                                </p>
                                <p className='padding_ecommerce' style={{padding:"0px 30px", marginTop:"0px"}}>
                                    El mantenimiento de computo consiste en la limpieza de la máquina en el hardware del CPU...
                                </p>
                                <div>
                                    <WavyLink direction={direction ? "up" : "down"} to="/servicio/mantenimiento-equipos" color={direction ? "#BF1F60" : "#2A79B0"}>
                                        <p class="boton_2 btn-servicios-3" id='mantenimiento_servicio' onMouseOver={hover} onMouseOut={hoverOut} onClick={cambio} style={{margin:"0 25px"}}>
                                            Conoce más 
                                        </p>
                                    </WavyLink>
                                </div>
                                {/* <a style={{marginLeft:"30px"}} class="boton_2 btn-servicios-3" id='mantenimiento_servicio' href='/servicio/mantenimiento-equipos' onMouseOver={hover} onMouseOut={hoverOut}> 
                                    Conoce más 
                                </a> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Inicio Vista Tablet y Movil */}

            <div className='row hide-on-large-only'>
                <div className='col s12 m6 servicio-d'>
                    <a href='/servicio/e-commerce'>
                        <div className='contenedor-servicios flexbox-servicios' style={{margin:"5px"}}>
                            <p className='titulo-servicios' style={{textAlign:"center", fontWeight:"bold"}}>E-commerce</p>

                            <img className="center-img dimensionar-imagen-tablet dimensionar-imagen-movil tablet-3" alt="" src={servicios1}></img>
                        </div>
                    </a>
                </div>
                <div className='col s12 m6 servicio-i'>
                    <a href='/servicio/aplicacion-movil'>
                        <div className='contenedor-servicios flexbox-servicios' style={{margin:"5px"}}>
                            <p className='titulo-servicios' style={{textAlign:"center", fontWeight:"bold"}}>Apps</p>
                            <img className="center-img dimensionar-imagen-tablet dimensionar-imagen-movil tablet-5" alt="" src={servicios2}></img>
                        </div>
                    </a>
                </div>
                <div className='col s12 m12 servicio-i'>
                    <a href='/servicio/sistemas-empresariales'>
                        <div className='contenedor-servicios-2 flexbox-servicios' style={{margin:"5px"}}>
                            <p className='titulo-servicios' style={{textAlign:"center", fontWeight:"bold"}}>Sistemas empresariales</p>

                            <img className="center-img dimensionar-imagen-tablet dimensionar-imagen-movil" alt="" src={servicios4}></img>
                        </div>
                    </a>
                </div>
                <div className='col s12 m6 servicio-d'>
                    <a href='/servicio/pagina-web'>
                        <div className='contenedor-servicios flexbox-servicios' style={{margin:"5px"}}>
                            <p className='titulo-servicios' style={{textAlign:"center", fontWeight:"bold"}}>Páginas Web</p>

                            <img className="center-img dimensionar-imagen tablet-3" alt="" src={servicios3}></img>
                        </div>
                    </a>
                </div>
                <div className='col s12 m6 servicio-i'>
                    <a href='/servicio/pagina-web#seo'>
                        <div className='contenedor-servicios flexbox-servicios' style={{margin:"5px"}}>
                            <p className='titulo-servicios' style={{textAlign:"center", fontWeight:"bold"}}>Optimización SEO</p>

                            <img className="center-img dimensionar-imagen-tablet-2 dimensionar-imagen-movil-2 tablet-4" alt="" src={servicios6}></img>
                        </div>
                    </a>
                </div>
                <div className='col s12 m12 servicio-d'>
                    <a href='/servicio/google-ads'>
                        <div className='contenedor-servicios-2 flexbox-servicios' style={{margin:"5px"}}>
                            <p className='titulo-servicios' style={{textAlign:"center", fontWeight:"bold"}}>Campañas Google ADS</p>

                            <img className="center-img dimensionar-imagen-tablet-2 dimensionar-imagen-movil-2" alt="" src={servicios5}></img>
                        </div>
                    </a>
                </div>
                <div className='col s12 m6 servicio-d'>
                    <a href='/servicio/animacion'>
                        <div className='contenedor-servicios flexbox-servicios' style={{margin:"5px"}}>
                            <p className='titulo-servicios' style={{textAlign:"center", fontWeight:"bold"}}>Animación</p>

                            <img className="center-img dimensionar-imagen-tablet dimensionar-imagen-movil tablet-3" alt="" src={servicios7}></img>
                        </div>
                    </a>
                </div>
                <div className='col s12 m6 servicio-i'>
                    <a href='/servicio/branding'>
                        <div className='contenedor-servicios flexbox-servicios' style={{margin:"5px"}}>
                            <p className='titulo-servicios' style={{textAlign:"center", fontWeight:"bold"}}>Diseño digital</p>

                            <img className="center-img dimensionar-imagen-tablet-2 dimensionar-imagen-movil-2 tablet-4" alt="" src={servicios8}></img>
                        </div>
                    </a>
                </div>
                <div className='col s12 m12'>
                    <a href='/servicio/mantenimiento-equipos'>
                        <div className='contenedor-servicios-2 flexbox-servicios' style={{margin:"5px"}}>
                            <p className='titulo-servicios' style={{textAlign:"center", fontWeight:"bold"}}>Mantenimiento a equipos</p>

                            <img className="center-img dimensionar-imagen-tablet dimensionar-imagen-movil" alt="" src={servicios9}></img>
                        </div>
                    </a>
                </div>
            </div>
            {/* Fin Vista Tablet y Móvil */}

            <Contacto/>
        </Fragment>
    );
}

export default Servicios;
